uniform float uStripeCount;
uniform float uStripeRatio;
uniform float uOffset;
uniform float uOpacity;
uniform vec3 uColor;

varying vec2 vUv;

precision mediump float;

void main() {

    float y = vUv.y * uStripeCount + uOffset;
    float stripe = mod(y, 1.0);

    float alpha = stripe < uStripeRatio ? 1.0 : uOpacity;

    gl_FragColor = vec4(uColor, alpha);
}